<template>
  <b-container class="py-5">
    <div v-if="!success">
      <b-row>
        <b-col class="text-center py-5">
          <img :src="logo" height="40px" alt />
          <h2>Registrate gratis</h2>
        </b-col>
      </b-row>
      <div class="py-4" style="display: flex; flex-direction: row; flex-wrap: wrap" role="form">
        <div class="col-sm-6">
          <label for="PymeRadio" class="radio-inline">
            <input type="radio" value="Pyme" id="Pyme" v-model="tipo" />
            Soy Pyme
          </label>
        </div>
        <div class="col-sm-6">
          <label for="ParticularRadio" class="radio-inline form-check-label">
            <input type="radio" value="Particular" id="Particular" v-model="tipo" />
            Soy Particular
          </label>
        </div>
      </div>
      <div class="my-5" role="form">
        <particular-registro
          :onSuccess="onSuccess"
          :tiposDocumento="tiposDocumento"
          v-if="tipo == 'Particular'"
        ></particular-registro>
        <pyme-registro v-else :onSuccess="onSuccess"></pyme-registro>
      </div>
    </div>
    <div v-else class="center">
      <div class="message-card container p-3" role="form">
        <h3>Registro Existoso</h3>
        <span>Tu registro fue existoso. Confirma tu email para obtener tu POBOX</span>
        <div class="volver-inicio">
          <button class="btn btn-primary" @click="goToHome()">Volver al inicio</button>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import ParticularRegistro from "@/components/Registro/ParticularRegistro.vue";
import PymeRegistro from "@/components/Registro/PymeRegistro.vue";
import logo from "@/assets/navbar-logo.svg";
import { getRegisterValue } from "@/service/api";
import { HOME_URL } from "../config";

export default {
  components: { ParticularRegistro, PymeRegistro },
  data() {
    return {
      tipo: "Pyme",
      tiposDocumento: [],
      logo,
      success: false,
    };
  },
  methods: {
    onSuccess() {
      this.success = true;
    },
    goToHome() {
      window.location.href = HOME_URL;
    },
  },
  mounted() {
    getRegisterValue().then((data) => {
      this.tiposDocumento = data.tipo_documento;
    });
  },
};
</script>
<style>
.formulario {
  min-height: 100vh;
}
.center {
  display: grid;
  place-items: center;
  min-height: 100vh;
}
.message-card {
  max-width: 500px;
}
.volver-inicio {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>